import React, { useEffect, useState } from 'react';
import { Toast, Modal } from 'react-bootstrap';
import api from '../../seller-apis/api';
import {
    orderRevoke,
} from '../../seller-apis/apidataField';
import PaginationCom from '../common/Pagination';
import Popup from '../common/Popup';
import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import { Actions } from '../../Actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import MainLoader from '../common/Loader/PageLoader';
var globalFilter = {
    "pageNo": 1
}

function RevokeOnly() {
    var outerdiv;
    var loaderDiv;
    const alert = useAlert()

    const [revokedOrd, setrevokedOrd] = useState([]);
    const [revokedRec, setrevokedRec] = useState(1);
    const [ennewloader, setennewloader] = useState("block");
    const [selectedOrder, setSelectedOrder] = useState();

    // Pagination related
    const [selectedPage, setSelectedPage] = useState(1);

    // Confirmation related
    const [confirmationState, setconfirmationState] = useState(false)
    const [msgConfirmation, setmsgConfirmation] = useState();
    const [selectedOrdername, setSelectedOrdername] = useState();
    // Toast

    const [showToast, setshowToast] = useState(false)
    const [toastmsg, setToastmsg] = useState("")
    const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");



    // Track order Popup

    const [selectedtrackOrder, setselectedtrackOrder] = useState(0);
    const [selectedTrackwithin, setselectedTrackwithin] = useState(0);

    //Product Detail Popup

    const [productDetail, setproductDetail] = useState([
        {
            "description": undefined,
            "sdescription": undefined,
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
        }
    ]);
    const [isDetailPopupVis, setisDetailPopupVis] = useState("block");


    // Web filter related states
    const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("block");
    const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
    const [detailPPrice, setdetailPPrice] = useState("");

    // Sl-976
    const stateData = useSelector(state => state?.ActionReducer);
    const dispatch = useDispatch();
    useEffect(() => {
        globalFilter = {
            "pageNo": "1",
        }
        api.order.orders(orderRevoke(globalFilter)).then((res) => {
            console.log(res)
            setrevokedOrd(res.data)
            setrevokedRec(res.totalRecords)
            setennewloader("none")
        }).catch((err) => {
            console.log(err)
            setennewloader("none")
        })

    }, [])


    function productPicked(id, status, pname) {
        if (status === "ASSIGN") {
            setToastmsg("Download manifest to proceed with pickup.")
            setshowToast(true)
        }
        else if (status === "DOWNLOAD") {
            setSelectedOrder(id)
            setSelectedOrdername(pname)
            setmsgConfirmation("Is product picked up by courier boy?")
            setconfirmationState(true)
        }
    }


    function setpopupVisibilityDetail(e) {
        if (e) {
            setisDetailPopupVis("block")
        }
        else {
            setisDetailPopupVis("none")
        }
    }


    function setpopupVisibilitytrackWeb(e) {
        if (e) {
            setisPopupTrackVisWeb("block")
        }
        else {
            setisPopupTrackVisWeb("none")
        }
    }

    // Popup showing detail
    function detail(data, price) {
        setdetailPPrice(price)
        if (data && data[0] === undefined) {
            setproductDetail(
                [
                    {
                        "description": "No details available",
                        "sdescription": "No short description",
                        "name": undefined,
                        "price": undefined,
                        "SKU": undefined,
                        "popupVisibility": undefined,
                        "images": []
                    }
                ]
            )
        }
        else {
            setproductDetail(data)
        }
    }

    // Pagination

    function paginate(data) {
        let loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        setselectedTrackwithin(0)
        setselectedtrackOrder(0)
        setselectedtrackOrderWeb(0)
        setSelectedPage(data.number)
        globalFilter.pageNo = data.number
        setennewloader("flex");
        api.order.orders(orderRevoke(globalFilter)).then((res) => {
            console.log(res.data)
            setrevokedOrd(res.data)
            setrevokedRec(res.totalRecords)
            loaderDiv.classList.remove("loader-bt");
            setennewloader("none")
        }).catch(err => {
            console.log(err)
            loaderDiv.classList.remove("loader-bt");
            setennewloader("none")
        })

    }


    // Revoke update

    function revCheck(status) {
        if (status === "success") {
            alert.success("Updated successfully")
            api.order.orders(orderRevoke(globalFilter)).then((res) => {
                setrevokedOrd(res.data)
                setrevokedRec(res.totalRecords)
                let ordersCount = {
                    ...stateData.orderCount, revoked: res.totalRecords
                }
                Actions.OrderCountAction(dispatch, ordersCount);
            }).catch((err) => {
                console.log(err)
            })
        }
    }


    // Function to close all popups opened

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.key === "Esc" || evt.key === "Escape") {
            setconfirmationState(false)
            setisPopupTrackVisWeb("none")
            setisDetailPopupVis("none")
        }
    };



    function applyLoader() {
        loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setennewloader("none")
    }


    return (
        <>

            <div className="" id="orDeskContain">


                {/* New orders desktop */}
                <div class="tab mx-2 table-responsive">
                    {/* <button className={`float-right py-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear Filter</button> */}
                    <table className='ord_table  new-table-design' style={{ "width": "100%" }}>
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title' style={{ "width": "10%" }}>Order ID
                                    {/* <br></br>
                                    <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "id")}></i> */}
                                </th>

                                <th className='thead_title pb-1' style={{ "width": "12%" }}>Assign Date<br></br>
                                    {/* <input type="date" name="name" className='input-date' value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")} />
                                    <input type="date" name="name" className='input-date' value={sortHistdateto} onChange={(e) => setdateweb(e, "to")} />
                                    <br></br> */}
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                                <th className='thead_title' style={{ "width": "20%" }}>Product Name
                                    {/* <input type="text" value={orderName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setorderName(e.target.value)} onKeyUp={(e) => checkevent(e, "name")} />
                                    <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "name")}></i> */}
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>Transfer price</th>
                                  <th className='thead_title' style={{ "width": "10%" }}>Pickup Address
                                    {/* <input type="text" value={addressName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setAddressName(e.target.value)} onKeyUp={(e) => checkevent(e, "address")} />
                                    <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "address")}></i> */}
                                </th>
                                <th className='thead_title' style={{ "width": "5%" }}>Total package</th>
                                <th className='thead_title' style={{ "width": "7%" }}>Order Pending From</th>

                                <th className='thead_title' style={{ "width": "19%" }}>Action required</th>
                            </tr>

                        </thead>
                        <tbody>
                            {/* {revokedOrd.length > 0 && compforPaginationweb === "allOrdersWeb" && selectedPage === 1 ? revokedOrd.map((item, index) => { */}
                            {revokedOrd.length > 0 ? revokedOrd.map((item, index) => {
                                let baseImg;
                                let date = new Date(item.createdAt);
                                let d = date.toUTCString(item.createdAt);
                                let newd = d.substr(4, 12)
                                let update = new Date(item.updatedAt);
                                let upd = update.toUTCString(item.updatedAt);
                                let upnewd = upd.substr(4, 12)

                                if (item.order?.products?.length > 0) {
                                    item.order.products[0].productId.images.map((item) => {
                                        if (item.baseImage === true) {
                                            if (item.image.startsWith("products")) {
                                                baseImg = item.image;
                                            }
                                            else {
                                                let img = item.image.substr("41")
                                                baseImg = img;
                                            }
                                        }
                                    })
                                    return (
                                        <OrderCardWeb id={index}
                                            type="New-Orders"
                                            key={item._id}
                                            orderMainId={item.order?._id}
                                            lead={item._id}
                                            nicknameAdd={item.order.products && item.order.products[0] && item.order.products[0].vendorDetails && item.order.products[0].vendorDetails.addrName ? item.order.products[0].vendorDetails.addrName : undefined}
                                            date={newd}
                                            updatedAt={upnewd}
                                            taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                                            orderId={item.order.products[0].pOrderId}
                                            url={item.order.products[0].productId.urlKey}
                                            sku={item.order.products[0].productId.SKU}
                                            productName={item.order.products[0].productId.productName}
                                            price={item.purchase_price}
                                            quantity={item.order.products[0].quantity}
                                            status={item.status}
                                            invoices={item.order.products[0].tracks}
                                            isProductPickedFun={productPicked}
                                            image={baseImg}
                                            spcl="revokeOnly"
                                            popupdetailVis={setpopupVisibilityDetail}
                                            popupVisibility={setpopupVisibilitytrackWeb}
                                            pdetail={detail}
                                            vendor={item.vendor}
                                            revokes={item.order.products[0].revokes}
                                            revokeCheck={revCheck}
                                            revokeReason={item.revoke}
                                            //Platform Fee Ticket : SL-662
                                            platformFee={item.order?.pfFees}
                                            // Sl-976
                                            revokeReasonType={item?.order?.products?.[0]?.revokeReasonType}
                                            product={item.order?.products?.[0]?.productId}
                                            order={item.order}
                                        />
                                    )
                                }
                            }) : <></>}
                        </tbody>
                    </table>

                    <PaginationCom
                        number={revokedRec}
                        activ={selectedPage}
                        paginate={paginate}
                        comp={compforPaginationweb}
                    />
                </div>

                <div class="d-flex justify-content-center" id="enNewLoader" >
                    <div style={{ "display": ennewloader }}>
                        <MainLoader />
                    </div>
                </div>



                {/* </div> */}

                {/* Toast */}
                <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
                    <Toast.Header>
                        <strong className="me-auto">Message</strong>
                    </Toast.Header>
                    <Toast.Body>{toastmsg}.</Toast.Body>
                </Toast>

                <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                    <Popup
                        from="newOrder"
                        description={productDetail[0].description}
                        sdescription={productDetail[0].shortDescription}
                        descriptionNew={productDetail[0].descriptionNew}
                        specificationNew={productDetail[0].specificationNew}
                        name={productDetail[0].productName}
                        price={detailPPrice}
                        SKU={productDetail[0].SKU}
                        popupVisibility={setpopupVisibilityDetail}
                        images={productDetail[0].images}
                        videos={productDetail[0].videos}
                    />
                </div>

            </div>
        </>
    )




}


export default RevokeOnly;